function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M7.656 8.422H.344a.092.092 0 0 0-.094.089v.712c0 .05.042.09.094.09h7.312c.052 0 .094-.04.094-.09v-.712c0-.05-.042-.09-.094-.09zM4 7.532a3.03 3.03 0 0 0 2.154-.894c.576-.575.893-1.34.893-2.154V.828a.141.141 0 0 0-.14-.14h-.704a.141.141 0 0 0-.14.14v3.656A2.066 2.066 0 0 1 4 6.547a2.066 2.066 0 0 1-2.063-2.063V.828a.141.141 0 0 0-.14-.14h-.703a.141.141 0 0 0-.14.14v3.656c0 .814.317 1.578.892 2.154.575.577 1.34.893 2.154.893z"
});

var SvgUnderline = function SvgUnderline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/underline.6e01422a.svg";
export { ForwardRef as ReactComponent };